<template>
  <div class="flex flex-col lg:w-full md:w-auto sm:w-auto mx-4 py-8 text-center bg-white border-2 border-gray-200 rounded-lg dark:bg-gray-800 dark:border-gray-700 min-w-0 tiktok-plan-C" style="height:385px;">
    <div class="text-center">
        <h2 class="font-semibold uppercase tiktok-plan-C-title">
          {{ plansListCData.plan_c_title }}
        </h2>
        <!-- <span class="text-gray-500">適合企業</span> -->
    </div>
    <div class="text-gray-700 text-center font-mono flex flex-wrap justify-center content-center py-4 my-4 bg-tiktok-plan-C">
      <div class="text-white">
        <p class="text-3xl">{{ plansListCData.plan_c_label_amount }}<span v-if="plansListCData.is_amount" class="text-sm ml-2">/{{lang['components']['Plan']['PlanC']['time_unit']}}</span></p>
        <!--<p v-if="plansListCData.is_amount" class="text-sm">per month</p>-->
      </div>
    </div>
    <ul class="flex-1 space-y-2 text-gray-500 dark:text-gray-400">
      <li v-for="(item, index) in description" class="border-b">
          {{ item }}
      </li>
    </ul>
    <!--<button v-if="plansListCData.plan_c_show" class="rounded-full bg-tiktok-plan-C mx-4 py-2 mt-12" :disabled="isDisabled" @click="handleChickPlan(plansListCData.plan_id, 'C')">
      {{ plansListCData.plan_c_text }}
    </button>-->
    <button v-if="plansListCData.plan_c_show" class="rounded-full bg-tiktok-plan-C mx-4 py-2 mt-12" @click="tiktokHandleChickPlan(plansListCData.plan_id, 'C', '', 'tiktok')">
      {{ plansListCData.plan_c_text }}
    </button>
    <button v-else-if="!plansListCData.planHaveBind" class="rounded-full bg-plan-A mx-4 py-2 mt-12" @click="tiktokHandleChickPlan(plansListCData.plan_id, 'C', '', 'tiktok')">
      {{lang['components']['Plan']['PlanC']['pay_use']}}
    </button>
    <button
      v-else
      class="rounded-full bg-red-500 mx-4 py-2 mt-12"
      v-if="isExpiredData && (plansListCData.plan_c_text == '使用中' || plansListCData.plan_c_text == 'Using')"
      @click="tiktokHandleChickPlan(plansListCData.plan_id, 'C', 'payAgain', 'tiktok')"
    >
      {{lang['components']['Plan']['PlanC']['plan_item_payagain_button_text']}}
    </button>
  </div>
</template>

<script>
export default {
  name: 'PlanC',
  props: {
    tiktokHandleChickPlan: {
      type: Function,
      default: () => ({})
    },
    plansListC:{
      type:Object,
      required:true
    },
    isExpired: {
      type: Boolean
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {
      payError: true
    };
  },
  computed: {
    plansListCData: {
      get: function () {
        return this.plansListC
      },
      set: function (value) {
        this.$emit('update:plansListCData', value)
      },
    },
    isExpiredData: {
      get: function () {
        return this.isExpired
      },
      set: function (value) {
        this.$emit('update:isExpiredData', value)
      },
    },
    description: function() {
       return this.plansListC.plan_c_description
    },
    isDisabled: function() {
       return this.plansListC.plan_c_disable
    }
  }
}
</script>

<style lang="scss" scope>
  .tiktok-plan-C {
    &:hover {
      border: 2px #F60E5F solid;
    }
  }
</style>